import type { MemberAiDailyBudgetCounter, MemberControls } from '../types/memberControls'

export interface MemberAiBudgetTarget {
  effectiveControls?: MemberControls | null
  aiBudgetCounter?: MemberAiDailyBudgetCounter | null
}

export function resolveMemberAiBudgetAndConsumption(
  memberProfile?: MemberAiBudgetTarget | null,
): {
  allowance: number
  consumed: number
} {
  const aiControl = memberProfile?.effectiveControls?.ai
  const allowance =
    aiControl?.mode === 'BUDGET' && typeof aiControl.dailyCredits === 'number'
      ? aiControl.dailyCredits
      : Number.POSITIVE_INFINITY
  const consumed = memberProfile?.aiBudgetCounter?.committed ?? 0
  return { allowance, consumed }
}
